import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { IPublicationRequestParams } from '@app/entities/interfaces/multimedia/publication.request.interface';
import { MultimediaMetadata } from '@app/entities/models/multimedia/multimedia-metadata.model';
import { AbstractPaginatedMultimediaItemResponse } from '@app/entities/models/multimedia/multimedia.abstract.model';
import { PublicationFeatured } from '@app/entities/models/multimedia/publication-featured.model';
import { Publication } from '@app/entities/models/multimedia/publication.model';

export interface PublicationRepository {
  getPaginatedItems(params: IPublicationRequestParams): Observable<AbstractPaginatedMultimediaItemResponse>;
  getItemWithMetadata(translationKey: string, params: object): Observable<MultimediaMetadata<Publication>>;
  getItem(translationKey: string, params: object): Observable<Publication>;
  getPublicItem(slug: string, params: object): Observable<Publication>;
  updateItemVisualizations(translationKey: string): Observable<number>;
  getPublicationFeatured(): Observable<PublicationFeatured>;
}

export const PUBLICATION_REPOSITORY = new InjectionToken<PublicationRepository>('PUBLICATION_REPOSITORY');
